'use client';

import { FC } from 'react';

import { NormalizedSalesTermCondition } from '@ravago/shared/page-data/models/contentful-mapped';
import { Box } from '@ravago/shared/radiance/components/box/components/Box/Box';
import { Link } from '@ravago/shared/radiance/components/link/components/Link/Link';

interface Props {
   legalEntities: NormalizedSalesTermCondition[];
   isConsumer?: boolean;
}

export const LegalEntitiesList: FC<Props> = ({ legalEntities, isConsumer }) => (
   <Box direction="column">
      {legalEntities.map((entity) => (
         <Link key={entity.id} {...(isConsumer && { href: entity.slug })}>
            {entity.ole.title}
         </Link>
      ))}
   </Box>
);
